<template>
    <div class="page">
        <Header></Header>
        <div class="page-container">

            <div class="container">
                <div class="form-container">
                    <b-card id="card">
                        <div style="min-height: 90px; background: black;">
                            <p style="font-family: 'Mansalva', cursive; font-weight: bold; font-size: 60px;
                                        background: black; color: white; margin: 0">Write an Article</p>
                        </div>
                        <div v-if="error">
                            <ul style="padding: 0; text-align: left;">
                                <li style="color: red; list-style: none; display: block; width: 100%;" v-bind:key="error"
                                    v-for="error in errors">{{ error }}</li>
                            </ul>
                        </div>
                        <b-form-textarea
                                id="textarea"
                                v-model="blogTitle.value"
                                v-bind:placeholder="titlePlaceholder"
                                rows="1"
                                max-rows="6"
                        ></b-form-textarea>
                        <div style="height: 25px; background: black"></div>
                        <div class="row" style="width: 100%; margin: 0">
                            <div class="input-group-left"
                             @drop.prevent="getFileDropped"
                             @dragover.prevent="fileOver = true"
                             @dragleave.prevent="fileOver = false"
                                 :style="{ 'background-image': `url(${fileImageString})` }"
                            >
                                <div class="input-group-prepend h-100" style="width: 100%;">
                                    <div style="text-align: right; width: 100%;"
                                         @click="chooseImage"
                                    >
                                        <span
                                                v-if="!fileImageString"
                                                class="placeholder"
                                        >
                                        Choose an Image
                                        </span>
                                        <input
                                                class="file-input"
                                                ref="file"
                                                type="file"
                                                id="imgSrc"
                                                @input="getFile"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="image-spacer"></div>
                            <div class="input-group-right"
                             @drop.prevent="getLowResFileDropped"
                             @dragover.prevent="lowResFileOver = true"
                             @dragleave.prevent="lowResFileOver = false"
                                 :style="{ 'background-image': `url(${lowResFileImageString})` }"
                            >
                                    <div class="input-group-prepend h-100" style=" width: 100%; text-align: left;">
                                        <div style="text-align: right; width: 100%;"
                                             @click="chooseLowResImage"
                                        >
                                        <span
                                                v-if="!lowResFileImageString"
                                                class="placeholder"
                                        >
                                        Low Resolution Version
                                        </span>
                                            <input
                                                    class="file-input"
                                                    ref="lowResFile"
                                                    type="file"
                                                    id="imgSrcLowRes"
                                                    @input="getLowResFile"
                                            >
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div style="height: 25px; background: black"></div>
                        <b-form-textarea
                                id="textarea"
                                v-model="teaserText.value"
                                v-bind:placeholder="teaserPlaceholder"
                                rows="3"
                                max-rows="6"
                        ></b-form-textarea>

                        <div v-for="n in counter" v-bind:key="n">
                            <p style="font-family: 'Mansalva', cursive; font-weight: bold; font-size: 60px;
                                background: linear-gradient(to left, black, #202020); margin: 0; color: white">Section {{n}}</p>
                                <b-form-textarea
                                        id="admin"
                                        v-model="content[(n-1)].title"
                                        v-bind:placeholder="titlePlaceholder"
                                        rows="1"
                                        max-rows="6"
                                ></b-form-textarea>
                            <div style="height: 25px; background: black"></div>
                            <div class="row" style="width: 100%; margin: 0">
                            <div class="input-group-left"
                                     @drop.prevent="getContentFileDropped"
                                     @dragover.prevent="lowResFileOver = true"
                                     @dragleave.prevent="lowResFileOver = false"
                                     :style="{ 'background-image': `url(${content[(n-1)].imgString})` }"
                                >
                                    <div class="input-group-prepend h-100" style="width: 100%">
                                        <div style="text-align: right; width: 100%;"
                                             @click="chooseContentImage(n-1)"
                                        >
                                        <span
                                                v-if="!content[(n-1)].imgString"
                                                class="placeholder"
                                        >
                                        Choose an Image
                                        </span>
                                            <input
                                                    class="file-input"
                                                    type="file"
                                                    :ref="n-1"
                                                    :id=n-1
                                                    @input="onClickFile(n-1)"
                                                    @change="renderFile(n-1)"
                                                    multiple
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="image-spacer"></div>
                                <div class="input-group-right"
                                     @drop.prevent="getLowResContentFileDropped(n)"
                                     @dragover.prevent="lowResFileOver = true"
                                     @dragleave.prevent="lowResFileOver = false"
                                     :style="{ 'background-image': `url(${content[(n-1)].lowResImgString})` }"
                                >
                                    <div class="input-group-prepend h-100" style="text-align: left; width: 100%">
                                        <div style="text-align: right; width: 100%;"
                                             @click="chooseLowResContentImage(n-1)"
                                        >
                                        <span
                                                v-if="!content[(n-1)].lowResImgString"
                                                class="placeholder"
                                        >
                                        Low Resolution Version
                                        </span>
                                            <input
                                                    class="file-input"
                                                    type="file"
                                                    :ref="'lowRes' + (n-1)"
                                                    :id="'lowRes' + (n-1)"
                                                    @input="onClickLowResFile(n-1)"
                                                    @change="renderLowResFile(n-1)"
                                                    multiple
                                            >
                                        </div>
                                    </div>
                                </div>
                                    </div>
                            <div style="height: 25px; background: black"></div>
                            <b-form-textarea
                                        id="admin"
                                        v-model="content[(n-1)].text"
                                        v-bind:placeholder="teaserPlaceholder"
                                        rows="3"
                                        max-rows="6"
                                ></b-form-textarea>
                        </div>
                    </b-card>
                </div>
                <div class="row" style="max-width: 800px; height: 100px; padding-left: 15px; padding-right: 15px">
                    <div class="container-button" style="min-width: 48%; max-width: 48%; height: 100px; display: inline-block;">
                        <b-button  @click="incrementCounter" type="submit" style="max-width: 300px;
                        display: block; margin: 20px auto; font-size: 10px; padding: 15px; height: 60px" pill variant="primary" class="btn btn-lg btn-block">Add Content</b-button>
                    </div>
                    <div style="display: inline-block; min-width: 4%; max-width: 4%; height: 100px"></div>
                    <div v-if="!loading" class="container-button" style="min-width: 48%; max-width: 48%; height: 100px; display: inline-block">
                        <b-button  @click="submit" type="submit" style="max-width: 300px;
            display: block; margin: 20px auto; padding: 15px; height: 60px" pill variant="outline-light" class="btn btn-lg btn-block">Send</b-button>
                    </div>
                    <div v-else class="container-button" style="min-width: 48%; max-width: 48%; height: 100px; display: inline-block">
                        <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center">
                            <b-spinner style="max-width: 300px;" variant= "light" label="Uploading ..."></b-spinner>
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    </div>
</template>

<script>
    import Header from "@/components/Header";
    import Footer from "@/components/Footer";
    import {mapActions, mapGetters} from "vuex";
    import UploadService from "@/service/UploadService";
    import Vue from 'vue';
    import {isNil} from "lodash";

    export default {
        name: "WriteBlog",
        components: {Header, Footer},
        data() {
            return {
                blogTitle: {
                    value: '',
                    valid: true
                },
                teaserText: {
                    value: '',
                    valid: true
                },

                isPermanentAdmin: false,
                error: false,
                titlePlaceholder: 'title',
                teaserPlaceholder: 'teaserText',
                errors: [],
                file: null,
                fileImageString: null,
                contentFiles: [],
                currentFile: null,
                contentLowResFiles: [],
                lowResFile: null,
                lowResFileImageString: null,
                timestamp: null,
                fileName: null,
                lowResFileName: null,
                correctFileType: false,
                correctLowResFileType: false,
                loading: false,
                fileOver: false,
                lowResFileOver: false,
                counter: 0,
                fileCounter: 0,
                lowResFileCounter: 0,
                content: [],
                contentImgString: null,
            };
        },
        computed: {
            ...mapGetters(['isAuthenticated']),
        },
        created() {
            Vue.prototype.$content = this.content;
            Vue.prototype.$vm = this;
        },
        methods: {
            ...mapActions(['uploadBlog']),
            chooseImage () {
                this.$refs.file.click()
            },
            getFile() {
                this.file = this.$refs.file.files[0];
                if (this.file !== null) {
                    this.fileName = this.file.name;
                    this.correctFileType = UploadService.checkFileType(this.file);
                    this.timestamp = UploadService.getTimeStamp();
                        const reader = new FileReader;
                        reader.onload = e => {
                            this.fileImageString = e.target.result;
                            console.log(e.target);
                            console.log(e.currentTarget);
                        };
                        reader.readAsDataURL(this.file);
                        this.$emit('input', this.file)
                    }
                console.log(this.fileImageString);
                    console.log('file: ' + this.file);
                    console.log('fileName: ' + this.fileName);
            },
            renderFile(n) {
                console.log(n);
                console.log('im rendering');
                console.log(this.currentFile);

                const reader = new FileReader;
                reader.onloadend = e =>
                    this.content[n].imgString = e.target.result;

                console.log(this.contentImgString);
                reader.readAsDataURL(this.content[n].file);
                this.$emit('input', this.content[n].file);

                let justToCheck = this.contentImgString;
                console.log('contentImgString: ' + justToCheck);
            },
            onClickFile(n) {
                let contentFileName = document.getElementById(n).files[0].name;
                let contentFile = document.getElementById(n).files[0];
                this.content[n].file = this.$refs[n][0].files[0];
                this.fileCounter++;

                this.contentFiles.push({
                    fileName: contentFileName,
                    file: contentFile,
                });

                console.log(this.content);
                console.log(this.contentFiles);
                this.getContentFile(n, contentFileName)
            },
            chooseContentImage(n) {
                document.getElementById(n).click();
            },
            getContentFile(n, contentFileName) {
                let contentElem = Vue.prototype.$content[n];
                contentElem.imgSrc = contentFileName;

                console.log(this.content);
                console.log(contentElem);
                console.log(contentFileName);

                this.content.splice(n, 1, contentElem);

                console.log(this.content);

            },
            chooseLowResContentImage(n) {
                document.getElementById('lowRes' + n).click();
            },
            onClickLowResFile(n) {
                let contentFileName = document.getElementById("lowRes"+ n).files[0].name;
                let contentFile = document.getElementById("lowRes"+ n).files[0];
                this.content[n].lowResFile = this.$refs['lowRes' + n][0].files[0];

                this.lowResFileCounter++;
                this.contentLowResFiles.push({
                    fileName: contentFileName,
                    lowResFile: contentFile,
                });

                console.log(this.content);
                console.log(this.contentLowResFiles);
                this.getContentLowResFile(n, contentFileName)
            },
            renderLowResFile(n) {

                const reader = new FileReader;
                reader.onloadend = e =>
                    this.content[n].lowResImgString = e.target.result;

                reader.readAsDataURL(this.content[n].lowResFile);
                this.$emit('input', this.content[n].lowResFile);

                let justToCheck = this.contentImgString;
                console.log('contentImgString: ' + justToCheck);
            },
            getContentLowResFile(n, contentFileName) {
                let contentElem = Vue.prototype.$content[n];
                contentElem.imgSrcLowRes = contentFileName;
                console.log(this.content);
                console.log(contentElem);
                console.log(contentFileName);

                this.content.splice(n, 1, contentElem);

                console.log(this.content);

            },
            getContentFileDropped(e) {
                this.file = e.target.files;
                console.log(this.file);
                if (this.file !== null) {
                    this.fileName = this.file.name;
                    this.correctFileType = UploadService.checkFileType(this.file);
                    this.timestamp = UploadService.getTimeStamp();
                    this.fileOver = false;
                }
            },
            getLowResContentFileDropped(e) {
                this.lowResFile = e.dataTransfer.files[0];
                if (this.lowResFile !== null) {
                    this.lowResFileName = this.lowResFile.name;
                    this.correctLowResFileType = UploadService.checkFileType(this.lowResFile);
                    this.timestamp = UploadService.getTimeStamp();
                    this.lowResFileOver = false;
                }
            },
            getFileDropped(e) {
                this.file = e.dataTransfer.files[0];
                if (this.file !== null) {
                    this.fileName = this.file.name;
                    this.correctFileType = UploadService.checkFileType(this.file);
                    this.timestamp = UploadService.getTimeStamp();
                    this.fileOver = false;
                }
            },
            chooseLowResImage () {
                this.$refs.lowResFile.click()
            },
            getLowResFile() {
                this.lowResFile = this.$refs.lowResFile.files[0];
                if (this.lowResFile !== null) {
                    this.lowResFileName = this.lowResFile.name;
                    this.correctLowResFileType = UploadService.checkFileType(this.lowResFile);
                    this.timestamp = UploadService.getTimeStamp();
                    const reader = new FileReader;
                    reader.onload = e => {
                        this.lowResFileImageString = e.target.result;
                    };
                    reader.readAsDataURL(this.lowResFile);
                    this.$emit('input', this.lowResFile)
                }
                console.log('inputFileString: ' + this.lowResFileImageString);
                    console.log('file: ' + this.lowResFile);
                    console.log('lowResFileName: ' + this.lowResFileName);
            },
            incrementCounter: function () {
                this.content.push({
                    title: null,
                    imgSrc: null,
                    imgSrcLowRes: null,
                    text: null,
                    imgString: null,
                    lowResImgString: null,
                    file: null,
                    lowResFile: null
                });
                this.counter++;
            },
            getLowResFileDropped(e) {
                this.lowResFile = e.dataTransfer.files[0];
                if (this.lowResFile !== null) {
                    this.lowResFileName = this.lowResFile.name;
                    this.correctLowResFileType = UploadService.checkFileType(this.lowResFile);
                    this.timestamp = UploadService.getTimeStamp();
                    this.lowResFileOver = false;
                }
            },
            async submit() {
                this.loading = true;
                for(let i = 0; i < this.content.length; i++) {
                   await  UploadService.uploadFile(this.content[i].file, this.content[i].imgSrc);
                   await  UploadService.uploadFile(this.content[i].lowResFile, this.content[i].imgSrcLowRes);
                }
                let allContentLowResFiles = this.contentLowResFiles;
                for(let i = 0; i < allContentLowResFiles.length; i++) {
                    if (!isNil(allContentLowResFiles[i].file)) {
                        await UploadService.uploadFile(allContentLowResFiles[i].file, allContentLowResFiles[i].fileName)
                    }
                }
                const uploadedFile = await UploadService.uploadFile(this.file, this.fileName);
                await UploadService.uploadFile(this.lowResFile, this.lowResFileName);
                console.log('uploaded file: ', uploadedFile);
                    //action to post blog
                    console.log('i started uploading blog');
                const uploadedBlog = await this.uploadBlog({
                    title: this.blogTitle.value,
                    fileName: this.fileName,
                    lowRes: this.lowResFileName,
                    teaserText: this.teaserText.value,
                    content: this.content
                });
                this.$router.push('/blog');
                console.log(uploadedBlog);
                this.loading = false;
            },
        },
    }
</script>

<style scoped>
    @import url("https://fonts.googleapis.com/css?family=Source+Code+Pro:300,400");

    .page {
        min-height: 100vh;
        width: 100vw;
    }

    .page-container {
        background: linear-gradient(to left, black, #202020);
        width: 100vw;
        min-height: 100vh;
        margin-top: 50px;
    }

    .container {
        max-width: 800px;
        min-height: 70vh;
        width: 98vw;
        padding-left: 1vw;
    }

    .input-group-left {
        width: 49%;
        height: 300px;
        background-size: cover; background-position: center center;
        margin: 0; padding: 0;
    }

    .input-group-right {
        width: 49%;
        height: 300px;
        background-size: cover; background-position: center center;
        margin: 0; padding: 0;
    }

    .image-spacer {
        width: 2%;
        height: 300px;
        background: black;
    }

    .placeholder {
        border: 1px solid gray;
        box-shadow: inset 0 0 10px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333;
        font-size: 18px;
        font-family: Helvetica;
        margin: 0;
        background: white;
    }
    .placeholder:hover {
        box-shadow: inset 0 0 15px;
    }
    .file-input {
        display: none;
    }

    @media only screen and (max-width: 500px) {
        .input-group-left {
            border-right: none;
            width: 100%;
        }

        .input-group-right {
            border-left: none;
            border-top: none;
            width: 100%;
        }

        .image-spacer {
            height: 25px;
            background: black;
            width: 100%;
        }
    }

</style>
